export default __webpack_public_path__ + "static/13-657e44a29c10d280743e5a9050593635.png";